import BankFeedActions from '../actions';

export const BankFeedUseDummy = {
    BANK_ACCOUNTS_WITH_BANK_FEED: false,
    BANK_ACCOUNT_WITH_CONNECTION: false, // T if want to show in View Account and Recon

    BANK_FEED_PENDING_CHECKER: false, // only this or BANK_FEED_MAP_ACCOUNTS_REQUEST can be T at a time
    [BankFeedActions.BANK_FEED_MAP_ACCOUNTS_REQUEST]: false, // To show the AccountMappingModal

    [BankFeedActions.BANK_FEED_READ_ALL_REQUEST]: false, // in /bank/feeds

    [BankFeedActions.BANK_FEED_CONNECT_REQUEST]: false, // call /ext/maybank/
    [BankFeedActions.BANK_FEED_DISCONNECT_REQUEST]: false, // call /ext/maybank/
    [BankFeedActions.BANK_FEED_SYNC_REQUEST]: false, // call /bank_feed/1/sync

    [BankFeedActions.BANK_FEED_TRANSACTION_READ_ALL_REQUEST]: false,
    [BankFeedActions.BANK_FEED_TRANSACTION_DELETE_REQUEST]: false,
    [BankFeedActions.BANK_FEED_TRANSACTION_BULK_DELETE_REQUEST]: false,

    [BankFeedActions.BANK_FEED_SMART_RECON_REQUEST]: false,
};
